module.exports = __webpack_public_path__ + "static/media/HumanBody-DNA2-Illustration.5cb64907.svg";